// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2825":"069e8edd","4044":"4bd998ad","5382":"069e8edd","6040":"f618dbef"}[chunkId] + ".chunk.css";
};